import { MediaObject } from '@anm/hosting-player';

export default (objects: MediaObject[]) =>
  objects.sort((a, b) => b.width - a.width);
